const WHATSAPP_SESSION_PATH = '/whatsapp/session'
const WHATSAPP_TEST_TEMPLATE_PATH = '/whatsapp/test-template'

export function normalizeBaseUrl(baseUrl = '') {
  return baseUrl.replace(/\/+$/, '')
}

export function getWhatsAppApiBaseUrl() {
  return normalizeBaseUrl(process.env.REACT_APP_API_STORE || '')
}

function isProductionEnvironment() {
  const appEnv = (process.env.REACT_APP_ENV || '').toLowerCase()
  const nodeEnv = (process.env.NODE_ENV || '').toLowerCase()

  return appEnv === 'prod' || appEnv === 'production' || nodeEnv === 'production'
}

function getWhatsAppEnvironmentToken() {
  return isProductionEnvironment() ? process.env.REACT_APP_WHATSAPP_PROD_TOKEN : process.env.REACT_APP_WHATSAPP_DEV_TOKEN
}

export function getWhatsAppHeaders() {
  const token = getWhatsAppEnvironmentToken()

  if (!token) {
    throw new Error('No está configurado el token interno de WhatsApp para este ambiente.')
  }

  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  }
}

async function parseWhatsAppResponse(response) {
  const text = await response.text()
  const data = text ? JSON.parse(text) : null

  if (!response.ok) {
    throw new Error(data?.message || data?.error || 'No fue posible completar la acción de WhatsApp.')
  }

  return data
}

async function requestWhatsApp(path, options = {}) {
  const baseUrl = getWhatsAppApiBaseUrl()

  if (!baseUrl) {
    throw new Error('Falta configurar REACT_APP_API_STORE para conectar WhatsApp.')
  }

  const response = await fetch(`${baseUrl}${path}`, {
    ...options,
    headers: {
      ...getWhatsAppHeaders(),
      ...(options.headers || {}),
    },
  })

  return parseWhatsAppResponse(response)
}

export function sendWhatsAppTemplate(payload, { useTestEndpoint = true } = {}) {
  const path = useTestEndpoint ? WHATSAPP_TEST_TEMPLATE_PATH : `${WHATSAPP_SESSION_PATH}/send-message`

  return requestWhatsApp(path, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function sendWhatsAppSessionMessage(payload) {
  return requestWhatsApp(`${WHATSAPP_SESSION_PATH}/send-message`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}
